export default __webpack_public_path__ + "static/media/293065817_489593256502302_323444016654407349_n.f8e155cd.jpg";